import { FctDialog } from '@/shared/ui';

import { useReportIssueHandler } from './use-report-issue-handler.hook';

type ReportIssueModalProps = {
  children: React.ReactNode;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  title: string;
};

function ReportIssueModal({ children, onOpenChange, open, title }: ReportIssueModalProps) {
  const { resetForm } = useReportIssueHandler();

  return (
    <FctDialog
      onOpenChange={() => {
        onOpenChange(false);
        resetForm();
      }}
      open={open}
      title={title}
    >
      <div className="w-full">{children}</div>
    </FctDialog>
  );
}

export { ReportIssueModal };
